import { useEffect } from 'react'
import debounce from '@doveconviene/sf-web-js-sdk/debounce'

const useOnWindowResize = (callback, bounce = 50) => {
  const handleResize = debounce(callback, bounce)

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [handleResize])
}

export default useOnWindowResize
